import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, isDevMode, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Calendar, CalendarModule } from "primeng/calendar";
import * as Holidays from 'date-holidays';
import { FloatLabel, FloatLabelModule } from 'primeng/floatlabel';
import { ClientService } from 'src/app/services/client.service';

@Component({
  selector: 'alice-dateSeletor',
  standalone: true,
  imports: [CalendarModule, CommonModule, FormsModule, ReactiveFormsModule, FloatLabelModule],
  templateUrl: "./AliceDateSeletor.component.html",
  styleUrls: ['./AliceDateSeletor.component.css'],
  changeDetection: ChangeDetectionStrategy.Default

})
export class AliceDateSeletorComponent implements OnInit, OnChanges {


  @ViewChild(Calendar) datePicker: any;

  //#region outputs
  @Output() DateChangeEvent = new EventEmitter();
  //#endregion

  //#region inputs
  @Input() IsAllowedHoliyDaySelect: boolean = false;
  /**
   * wheater or not today is able to be clicked on.
   */
  @Input() PickUpSameDayAllowed: boolean = false;;
  /**
   * what date to start the date selctor on.
   */
  @Input() defualtStartDate: Date = new Date();
  /**
   * wheater or not to displely weekden as a clickable date
   */
  @Input() AllowWeekdenBooking: boolean = false;
  /**
 * Tooltip position: 'top' | 'bottom' | 'left' | 'right'
 */
  @Input() ToolTipPos: 'top' | 'bottom' | 'left' | 'right' = 'top';

  @Input() IsSender!: boolean;

  @Input() minDate!: Date;
  //#endregion 

  //#region dateSelectorProps  
  disabledDates = new Array<Date>() // a array of dates that should not be selectable. 
  disabledDays = this.AllowWeekdenBooking ? [] : [0, 6] // the days that should not be selectable (weekdens sat = 0,sun = 6)
  holidays = new Array<any>();
  currentSelectedMonth = new Date().getMonth() - 1;
  currentYear = new Date().getFullYear();
  currentYearHolidysArray = new Array<DateSelecterObject>();
  toDayDate = new Date();
  //#endregion

  constructor(private clientService: ClientService) { }

  ngOnInit(): void {
    const isEurofins = this.clientService.clientTenant === 'Eurofins';
    this.disabledDays = this.IsSender || isEurofins || !this.AllowWeekdenBooking ? [0, 6] : [];

    this.defualtStartDate = this.defualtStartDate ? new Date(this.defualtStartDate) : new Date();
    this.minDate = this.minDate ? new Date(this.minDate) : new Date();

    this.GetHoliyDays('DK');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['AllowWeekdenBooking'] || changes['IsSender']) {
      let isEurofins = this.clientService.clientTenant === 'Eurofins';
      this.disabledDays = this.IsSender || isEurofins || !this.AllowWeekdenBooking ? [0, 6] : [];
    }

    if (changes['IsAllowedHoliyDaySelect'] && !changes['IsAllowedHoliyDaySelect'].firstChange)
      this.GetHoliyDays('DK');

  }

  /**
   * 
   * @param country what countyr to use when bakeing the holiydays into the calendar datesleltor  thing.
   */
  GetHoliyDays(country = "DK") {
    // this overrides dansih holiydays becuse for some odd reasion the drivers have deffrent holiydays then the rest of the dansih pepole.
    let dansihHoliyDaysOverRide = ["Første maj", "Grundlovsdag", "Juleaften", "Nytårsaften"];
    let hd = new Holidays.default(country, null, null, { types: ['public', 'bank'] });
    let holidaysList = hd.getHolidays(new Date().getFullYear());
    if (!this.IsAllowedHoliyDaySelect) {
      this.disabledDates = holidaysList
        .filter(h => h.type === "public" || dansihHoliyDaysOverRide.includes(h.name))
        .map(h => {
          let day = h.date.split('-')[2].split(' ')[0];
          let year = h.date.split('-')[0];
          let month = h.date.split('-')[1]
          return new Date(Number.parseInt(year), Number.parseInt(month) - 1, Number.parseInt(day));
        }
        );
    }
    //builds a simple array to be used later when the need to find a spicifk date for tooltiping.
    let templist = new Array<DateSelecterObject>();
    holidaysList.map(h => h).forEach(x => {
      if (x.type == "public" || dansihHoliyDaysOverRide.includes(x.name))
        templist.push({ name: x.name, data: new Date(x.date) })
    });
    this.currentYearHolidysArray = templist;
  }

  /**
   * this builds the calnendar when clicked on by the user.
   */
  onCalendarShown() {
    this.markHolidayCells(new Date().getMonth() + 1);
  }
  /**
   * this is to make sure holiydays is renderer corrertly when change month.
   * @param event pCalndar monthchange event
   */
  onMonthChange(event: any) {
    this.currentSelectedMonth = event.month;
    setTimeout(() => { this.markHolidayCells(event.month); }, 50);
  }
  /**
   * this function is a ugly ass override for what a datepicker can do natively.....
   * TODO: when prime is updatet to apove V15 then all of this crap can be deleted.
   * @param month the month datepicker is in.
   */
  markHolidayCells(month: number) {
    let calendarCells = document.querySelectorAll('.p-datepicker-calendar td span');
    let lastSeenDay = undefined;
    let currentDay = Number.parseInt(calendarCells[0].textContent?.trim());
    month = month - 1;
    let bais = 0;

    if (currentDay > 1)
      bais = 1;

    calendarCells.forEach((cell) => {
      const dayText = cell.textContent?.trim();
      if (!dayText) return;

      currentDay = Number.parseInt(cell.textContent?.trim());
      if (lastSeenDay != undefined && currentDay < lastSeenDay) bais--;

      let today = new Date(new Date().getFullYear(), month - bais, currentDay);
      let cellDate = new Date(today.getFullYear(), today.getMonth(), Number.parseInt(dayText));

      if (this.disabledDates.find(x => x.valueOf() == cellDate.valueOf())) {
        (cell as HTMLElement).style.backgroundColor = 'rgb(40 109 254)'; // blue ish color
        (cell as HTMLElement).style.borderRadius = '25%';
        (cell as HTMLElement).style.fontWeight = 'bold';
        (cell as HTMLElement).classList.add("calendarDateTollTipTest");
        (cell as HTMLElement).id = cellDate.valueOf().toString();
        let holidayName = this.currentYearHolidysArray.find(d => d.data.valueOf() == cellDate.valueOf())?.name;
        (cell as HTMLElement).setAttribute('data-holiday-name', holidayName);
        (cell as HTMLElement).onmouseout = (ev) => { this.MouseLeaveEvent(ev) }
        (cell as HTMLElement).onmouseenter = (ev) => { this.MouseEnterEvent(ev) }
      }
      lastSeenDay = currentDay;
    });
  }

  //#region mouseEvents
  MouseEnterEvent(event: MouseEvent) {
    this.ShowToolTip(event, false)
  }

  MouseLeaveEvent(event: MouseEvent) {
    this.ShowToolTip(event, true)
  }

  /**
   * 
   * @param event MouseEvent
   * @param toBeHidden weather or not the toolip is to be shwon
   * @returns null | void
   * Note: this releys on a attribute named data-holiday-name whice is stored on the cell html element itself.
   * this makes it a lot faster to write out the name of the holiday indsted of doing stupid date math..
   */
  ShowToolTip(event: MouseEvent, toBeHidden = false) {
    let target = event.target as HTMLElement;
    if (toBeHidden) {
      const existingTooltip = document.getElementById('custom-tooltip');
      if (existingTooltip) existingTooltip.remove();
      return;
    }
    let existingTooltip = document.getElementById('custom-tooltip');
    if (existingTooltip) existingTooltip.remove();
    let holidayName = target.getAttribute('data-holiday-name') || target.innerText;
    let tooltip = document.createElement('div');
    tooltip.id = 'custom-tooltip';
    tooltip.innerText = holidayName;
    tooltip.style.position = 'fixed';
    tooltip.style.backgroundColor = 'black';
    tooltip.style.color = 'white';
    tooltip.style.padding = '5px 10px';
    tooltip.style.borderRadius = '5px';
    tooltip.style.fontSize = '15px';
    tooltip.style.pointerEvents = 'none';
    tooltip.style.zIndex = '9000';
    document.body.appendChild(tooltip);

    let rect = target.getBoundingClientRect();
    let offsetX = 10;
    let offsetY = -35;

    switch (this.ToolTipPos) {
      case "bottom":
        offsetY = 35;
        break;
      case "top":
        offsetY = -35;
        break;
      case "right":
        offsetX = rect.width + 10;
        offsetY = 0;
        break;
      case "left":
        offsetX = -tooltip.getBoundingClientRect().width - 10;
        offsetY = 0;
        break;
    }
    tooltip.style.left = `${rect.left + offsetX}px`;
    tooltip.style.top = `${rect.top + offsetY}px`;
  }
  //#endregion
  /**
   * this emits a date when called. use to get the date back to the caller and then the caller can do stuff with it.
   * @param event the date to send back to the parrent
   */
  CheckDate(event: Date) {
    this.DateChangeEvent.emit({ event })
  }
  /**
   * this ensures that evey time the little dropdown is closed, it will refreash the holydays and redraw the little modal.
   */
  onClose() {
    this.currentSelectedMonth = new Date().getMonth() - 1;
  }

}

export interface DateSelecterObject {
  name: string;
  data: Date;
}


